import React from "react";
import { LangContext } from "../../context/lang/LangContext";
import { Wrapper } from "../../components/Wrapper/Wrapper";
import { spanish } from "../../context/lang/langs/spanishMessages";
import HeadTagEs from "../../components/EarlyAccess/HeadTagEs";

const EarlyAccess = React.lazy(
  () => import(`../../components/EarlyAccess/EarlyAccess`),
);

const Index = () => {
  return (
    <>
      <LangContext.Provider value={{ messages: spanish }}>
        <Wrapper>
          <EarlyAccess />
        </Wrapper>
      </LangContext.Provider>
    </>
  );
};

export function Head() {
  return (
    <>
      <html lang="es" />
      <meta httpEquiv="content-language" content="es"></meta>
      <HeadTagEs />
    </>
  );
}

export default Index;
